
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Membre = lazy(() => import('../pages/membre/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const LeadDetail = lazy(() => import('../pages/lead-detail/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const InscriptionCandidatPage = lazy(() => import('../pages/inscription-candidat/page'));
const ConseilsPage = lazy(() => import('../pages/conseils/page'));
const MentionsLegales = lazy(() => import('../pages/mentions-legales/page'));
const ExpertisesPage = lazy(() => import('../pages/expertises/page'));
const HauteGaronnePage = lazy(() => import('../pages/haute-garonne/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/membre',
    element: <Membre />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/lead-detail',
    element: <LeadDetail />,
  },
  {
    path: '/inscription-candidat',
    element: <InscriptionCandidatPage />,
  },
  {
    path: '/conseils',
    element: <ConseilsPage />,
  },
  {
    path: '/expertises',
    element: <ExpertisesPage />,
  },
  {
    path: '/haute-garonne',
    element: <HauteGaronnePage />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegales />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
